export default "__VITE_PUBLIC_ASSET__7e10db91__"